document.addEventListener('DOMContentLoaded', function () {

  var routes = (window.theme && window.theme.routes) || {
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    cartUrl: '/cart'
  };

  /* ================================================================
     MOBILE HAMBURGER MENU
  ================================================================= */
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var mobileNavDrawer = document.getElementById('mobileNavDrawer');
  var mobileNavOverlay = document.getElementById('mobileNavOverlay');
  var mobileNavClose = document.getElementById('mobileNavClose');

  function openMobileNav() {
    if (!mobileNavDrawer) return;
    closeCartDrawer();
    mobileNavDrawer.classList.add('open');
    mobileNavOverlay.classList.add('visible');
    mobileNavDrawer.setAttribute('aria-hidden', 'false');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    hamburgerBtn.classList.add('active');
    document.body.classList.add('scroll-lock');
  }

  function closeMobileNav() {
    if (!mobileNavDrawer) return;
    mobileNavDrawer.classList.remove('open');
    mobileNavOverlay.classList.remove('visible');
    mobileNavDrawer.setAttribute('aria-hidden', 'true');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    hamburgerBtn.classList.remove('active');
    if (!isCartDrawerOpen()) document.body.classList.remove('scroll-lock');
  }

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', function () {
      if (mobileNavDrawer.classList.contains('open')) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });
  }
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* ================================================================
     AJAX CART DRAWER
  ================================================================= */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  var cartDrawerClose = document.getElementById('cartDrawerClose');
  var cartToggleBtn = document.getElementById('cartToggleBtn');
  var cartDrawerBody = document.getElementById('cartDrawerBody');
  var cartDrawerItems = document.getElementById('cartDrawerItems');
  var cartDrawerEmpty = document.getElementById('cartDrawerEmpty');
  var cartDrawerFooter = document.getElementById('cartDrawerFooter');
  var cartDrawerSubtotal = document.getElementById('cartDrawerSubtotal');
  var cartDrawerCount = document.getElementById('cartDrawerCount');
  var cartDrawerContinue = document.getElementById('cartDrawerContinue');
  var cartCountBadge = document.getElementById('cartCount');

  function isCartDrawerOpen() {
    return !!(cartDrawer && cartDrawer.classList.contains('open'));
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    closeMobileNav();
    cartDrawer.classList.add('open');
    cartDrawerOverlay.classList.add('visible');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-lock');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawerOverlay.classList.remove('visible');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (!(mobileNavDrawer && mobileNavDrawer.classList.contains('open'))) {
      document.body.classList.remove('scroll-lock');
    }
  }

  function moneyFromCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerItems) return;

    if (cartCountBadge) {
      if (cart.item_count > 0) {
        cartCountBadge.textContent = cart.item_count;
        cartCountBadge.style.display = '';
      } else {
        cartCountBadge.style.display = 'none';
      }
    }
    if (cartDrawerCount) cartDrawerCount.textContent = '(' + cart.item_count + ')';
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = moneyFromCents(cart.total_price);

    if (cart.item_count === 0) {
      if (cartDrawerEmpty) cartDrawerEmpty.style.display = '';
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
      cartDrawerItems.innerHTML = '';
      return;
    }

    if (cartDrawerEmpty) cartDrawerEmpty.style.display = 'none';
    if (cartDrawerFooter) cartDrawerFooter.style.display = '';

    cartDrawerItems.innerHTML = cart.items.map(function (item, index) {
      var imgSrc = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_160x$1$2') : '';
      return (
        '<div class="cart-drawer-item" data-line="' + (index + 1) + '">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '') + '">' : '') +
          '<div class="cart-drawer-item-info">' +
            '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
            '<div class="cart-drawer-item-variant">' + (item.variant_title || '') + '</div>' +
            '<div class="cart-drawer-item-row">' +
              '<div class="cart-drawer-qty" data-line="' + (index + 1) + '">' +
                '<button type="button" class="cart-drawer-qty-minus">–</button>' +
                '<span class="mono cart-drawer-qty-value">' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer-qty-plus">+</button>' +
              '</div>' +
              '<div class="mono cart-drawer-item-price">' + moneyFromCents(item.line_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-drawer-remove" data-line="' + (index + 1) + '" aria-label="Remove">&times;</button>' +
        '</div>'
      );
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      });
  }

  if (cartToggleBtn) {
    cartToggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart();
      openCartDrawer();
    });
  }
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  if (cartDrawerContinue) cartDrawerContinue.addEventListener('click', closeCartDrawer);

  if (cartDrawerItems) {
    cartDrawerItems.addEventListener('click', function (e) {
      var target = e.target;
      if (target.classList.contains('cart-drawer-qty-plus') || target.classList.contains('cart-drawer-qty-minus')) {
        var wrap = target.closest('.cart-drawer-qty');
        var line = parseInt(wrap.dataset.line, 10);
        var valueEl = wrap.querySelector('.cart-drawer-qty-value');
        var current = parseInt(valueEl.textContent, 10) || 1;
        var next = target.classList.contains('cart-drawer-qty-plus') ? current + 1 : Math.max(0, current - 1);
        changeLine(line, next);
      } else if (target.classList.contains('cart-drawer-remove')) {
        changeLine(parseInt(target.dataset.line, 10), 0);
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileNav();
    }
  });

  // Load cart contents once up front so the badge/drawer are correct on any page.
  fetchCart();

  /* ================================================================
     AJAX ADD TO CART (intercepts the PDP form so shoppers stay on
     the page and see the drawer instead of a full navigation)
  ================================================================= */
  var productForm = document.getElementById('product-form');
  var buyNowBtn = document.getElementById('buyNowBtn');

  function addToCartRequest() {
    var formData = new FormData(productForm);
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = document.getElementById('addToCartBtn');
      var originalText = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      addToCartRequest()
        .then(function () { return fetchCart(); })
        .then(function () {
          if (window.a11yAnnounce) window.a11yAnnounce('Added to bag.');
          openCartDrawer();
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
        })
        .catch(function (err) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
          alert((err && err.description) || 'Sorry, that item could not be added to your bag.');
        });
    });
  }

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var originalText = buyNowBtn.textContent;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Adding…';
      addToCartRequest()
        .then(function () {
          window.location.href = routes.cartUrl.replace(/\/$/, '') === '' ? '/checkout' : '/checkout';
        })
        .catch(function (err) {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = originalText;
          alert((err && err.description) || 'Sorry, that item could not be added to your bag.');
        });
    });
  }

  /* ================================================================
     TRACK YOUR ORDER FORM
  ================================================================= */
  var trackOrderForm = document.getElementById('trackOrderForm');
  var trackOrderResult = document.getElementById('trackOrderResult');
  if (trackOrderForm) {
    trackOrderForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderNumber = document.getElementById('trackOrderNumber').value.trim();
      if (trackOrderResult) {
        trackOrderResult.style.display = '';
        trackOrderResult.innerHTML =
          '<p><strong>Thanks — we found your request for ' + (orderNumber || 'your order') + '.</strong></p>' +
          '<p>Tracking links are sent by email as soon as your order ships. If it\'s already shipped, check your ' +
          'inbox (and spam folder) for a message from us, or sign in to your account to see every order and its status in one place.</p>';
      }
    });
  }

  /* ---------- Gallery thumbnail swap ---------- */
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.pdp-thumb').forEach(function (t) {
        t.classList.remove('active');
        t.removeAttribute('aria-current');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-current', 'true');
      var mainImg = document.getElementById('pdpMainImg');
      if (mainImg) mainImg.src = thumb.dataset.full;
    });
  });

  /* ---------- Product form (PDP) variant logic ---------- */
  var pdpSection = document.querySelector('.pdp[data-product-json]');
  if (pdpSection) {
    var product = JSON.parse(pdpSection.dataset.productJson);
    var variantIdInput = document.getElementById('variantIdInput');
    var addBtn = document.getElementById('addToCartBtn');
    var priceEl = document.getElementById('pdpPrice');
    var mainImg = document.getElementById('pdpMainImg');
    var colorLabel = document.getElementById('colorLabel');

    var selected = {};
    var initialVariant = product.variants.find(function (v) { return v.id == variantIdInput.value; }) || product.variants[0];
    if (initialVariant) {
      selected['Color'] = initialVariant.option1;
      selected['Size'] = initialVariant.option2;
    }

    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return product.variants.find(function (v) {
        var matchColor = !selected['Color'] || v.option1 === selected['Color'];
        var matchSize = !selected['Size'] || v.option2 === selected['Size'];
        return matchColor && matchSize;
      });
    }

    function updateAvailability() {
      document.querySelectorAll('.size-pill').forEach(function (pill) {
        var value = pill.dataset.value;
        var match = product.variants.find(function (v) {
          return v.option1 === selected['Color'] && v.option2 === value;
        });
        var soldOut = !!match && !match.available;
        pill.classList.toggle('disabled', soldOut);
        if (soldOut) {
          pill.setAttribute('disabled', 'disabled');
          pill.setAttribute('aria-disabled', 'true');
        } else {
          pill.removeAttribute('disabled');
          pill.removeAttribute('aria-disabled');
        }
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (colorLabel) colorLabel.textContent = selected['Color'] || '';
      if (mainImg && variant.featured_image) mainImg.src = variant.featured_image.src || variant.featured_image;

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.classList.remove('disabled');
          addBtn.textContent = 'Add to Bag — ' + moneyFormat(variant.price);
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('disabled');
          addBtn.textContent = 'Sold Out';
        }
      }
      updateAvailability();
    }

    document.querySelectorAll('.color-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        document.querySelectorAll('.color-swatch').forEach(function (s) {
          s.classList.remove('active');
          s.setAttribute('aria-pressed', 'false');
        });
        sw.classList.add('active');
        sw.setAttribute('aria-pressed', 'true');
        selected['Color'] = sw.dataset.value;
        updateUI();
      });
    });

    document.querySelectorAll('.size-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('disabled')) return;
        document.querySelectorAll('.size-pill').forEach(function (p) {
          p.classList.remove('active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-pressed', 'true');
        selected['Size'] = pill.dataset.value;
        updateUI();
      });
    });

    updateUI();
  }

  /* ---------- Quantity stepper ---------- */
  var qtyInput = document.getElementById('qtyInput');
  var qtyMinus = document.getElementById('qtyMinus');
  var qtyPlus = document.getElementById('qtyPlus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }

  /* ---------- Accordion ---------- */
  document.querySelectorAll('.acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      var isOpen = item.classList.toggle('open');
      head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

});

/* =========================================================
   CURVE EDIT — size chart cm / inch toggle
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-size-table]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('.unit-btn');
    var cells = wrap.querySelectorAll('td[data-cm]');
    if (!buttons.length || !cells.length) return;

    function cmToIn(text) {
      return text.replace(/[\d.]+/g, function (num) {
        var inches = parseFloat(num) / 2.54;
        return String(Math.round(inches * 2) / 2);
      });
    }

    function setUnit(unit) {
      cells.forEach(function (cell) {
        var cm = cell.getAttribute('data-cm') || '';
        cell.textContent = unit === 'in' ? cmToIn(cm) : cm;
      });
      buttons.forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-unit') === unit);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setUnit(btn.getAttribute('data-unit'));
      });
    });
  });
});

/* =========================================================
   ACCESSIBILITY TOOLBAR
   Display preferences for low-vision, dyslexic and
   motion-sensitive shoppers. Screen reader users do not need
   this — they get what they need from the semantic markup.
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  var STORE_KEY = 'w3t-a11y';
  var root = document.documentElement;
  var toggle = document.getElementById('a11yToggle');
  var panel = document.getElementById('a11yPanel');
  var closeBtn = document.getElementById('a11yClose');
  var resetBtn = document.getElementById('a11yReset');
  var readBar = document.getElementById('a11yReadBar');
  var stopBtn = document.getElementById('a11yStopSpeech');
  var live = document.getElementById('a11yLiveRegion');

  /* Announce a short message to screen readers without moving focus. */
  window.a11yAnnounce = function (message) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  };

  if (!toggle || !panel) return;

  var state = { textSize: 0, contrast: false, underline: false, motion: false, readaloud: false };
  try {
    var saved = JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
    Object.keys(state).forEach(function (k) {
      if (typeof saved[k] !== 'undefined') state[k] = saved[k];
    });
  } catch (e) {}

  function persist() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function apply() {
    root.classList.remove('a11y-text-1', 'a11y-text-2');
    if (state.textSize) root.classList.add('a11y-text-' + state.textSize);
    root.classList.toggle('a11y-contrast', !!state.contrast);
    root.classList.toggle('a11y-underline', !!state.underline);
    root.classList.toggle('a11y-reduce-motion', !!state.motion);
    root.classList.toggle('a11y-readaloud', !!state.readaloud);

    panel.querySelectorAll('[data-text-size]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(Number(btn.dataset.textSize) === Number(state.textSize)));
    });
    panel.querySelectorAll('[data-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(!!state[btn.dataset.toggle]));
    });
    if (readBar) readBar.hidden = !state.readaloud;
    persist();
  }

  /* ---------- Open / close ---------- */
  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('button');
    if (first) first.focus();
  }
  function closePanel(returnFocus) {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus !== false) toggle.focus();
  }

  toggle.addEventListener('click', function () {
    if (panel.hidden) { openPanel(); } else { closePanel(); }
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(); });

  document.addEventListener('keydown', function (e) {
    if (e.altKey && (e.key === '0' || e.code === 'Digit0')) {
      e.preventDefault();
      if (panel.hidden) { openPanel(); } else { closePanel(); }
    }
    if (e.key === 'Escape' && !panel.hidden) closePanel();
  });

  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (panel.contains(e.target) || toggle.contains(e.target)) return;
    closePanel(false);
  });

  /* ---------- Controls ---------- */
  panel.querySelectorAll('[data-text-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.textSize = Number(btn.dataset.textSize);
      apply();
      window.a11yAnnounce(['Default text size', 'Larger text', 'Largest text'][state.textSize]);
    });
  });

  var LABELS = {
    contrast: 'High contrast',
    underline: 'Underline links',
    motion: 'Reduce motion',
    readaloud: 'Read aloud'
  };

  panel.querySelectorAll('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.toggle;
      state[key] = !state[key];
      if (key === 'readaloud' && !state[key]) stopSpeech();
      apply();
      window.a11yAnnounce(LABELS[key] + (state[key] ? ' on' : ' off'));
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      state = { textSize: 0, contrast: false, underline: false, motion: false, readaloud: false };
      stopSpeech();
      apply();
      window.a11yAnnounce('Display settings reset.');
    });
  }

  /* ---------- Read aloud ---------- */
  var synth = window.speechSynthesis || null;

  function stopSpeech() {
    if (synth && synth.speaking) synth.cancel();
    document.querySelectorAll('.a11y-speaking').forEach(function (el) {
      el.classList.remove('a11y-speaking');
    });
  }

  function speak(el) {
    if (!synth) return;
    var text = (el.innerText || el.textContent || '').trim();
    if (!text) return;
    stopSpeech();
    var utterance = new SpeechSynthesisUtterance(text.slice(0, 600));
    utterance.lang = document.documentElement.lang || 'en';
    utterance.rate = 0.95;
    el.classList.add('a11y-speaking');
    utterance.onend = function () { el.classList.remove('a11y-speaking'); };
    synth.speak(utterance);
  }

  document.addEventListener('click', function (e) {
    if (!state.readaloud) return;
    if (panel.contains(e.target) || toggle.contains(e.target)) return;
    if (readBar && readBar.contains(e.target)) return;
    var el = e.target.closest('p, h1, h2, h3, h4, li, dd, blockquote, td, th, .card-info, .fit-meta, .acc-body');
    if (!el) return;
    e.preventDefault();
    speak(el);
  });

  if (stopBtn) stopBtn.addEventListener('click', stopSpeech);
  window.addEventListener('beforeunload', stopSpeech);

  if (!synth) {
    var readSwitch = panel.querySelector('[data-toggle="readaloud"]');
    if (readSwitch) readSwitch.hidden = true;
  }

  apply();
});
